import type { FieldTemplateProps, RJSFSchema } from '@rjsf/utils';

import type { FormWriterContext } from '@/components/forms/components/form/writer';
import {
  FormDescription,
  FormHelp,
  FormLabel
} from '@/components/forms/ui/ui.form';

export type FieldTemplatePropsTrace = FieldTemplateProps<
  unknown,
  RJSFSchema,
  FormWriterContext
>;

export const FieldTemplate = ({
  id,
  label,
  children,
  rawHelp,
  hidden = false,
  required = false,
  /* ⚠️ Field items have their displayLabel to false. */
  displayLabel = true,
  formContext,
  schema,
  rawDescription
}: FieldTemplatePropsTrace) => {
  if (hidden) return children;

  return (
    <div className="mb-5" id={`container-${id}`}>
      {displayLabel && (
        <>
          <FormLabel
            formContext={formContext}
            id={id}
            label={label}
            required={required}
          />
          {schema.type !== 'object' && (
            <FormDescription id={id} rawDescription={rawDescription} />
          )}
        </>
      )}

      {children}
      {displayLabel && <FormHelp id={id} rawHelp={rawHelp} />}
    </div>
  );
};
